import "./GarageDoorRepairBlueMountains.module.css";
import Header from "@/reusable_sections/Header";
import Bluemountainshero from "./sections/Bluemountainshero";
import Garage from "./sections/Garage";
import Services from "./sections/Services";
import Brands from "./sections/Brands";
import ServiceProcessSteps from "./sections/ServiceProcessSteps";
import WhyChooseUs from "./sections/WhyChooseUs";
import Suburbs from "./sections/Suburbs";
import Testimonials from "./sections/Testimonials";
import Garagefaq from "./sections/Garagefaq";
import Contact from "./sections/Contact";
import LocationFooter from "./sections/LocationFooter";
export default function GarageDoorRepairBlueMountainsPage() {
  return <div>
      <Header />
      <Bluemountainshero />
      <Garage />
      <Services />
      <Brands />
      <ServiceProcessSteps />
      <WhyChooseUs />
      <Suburbs />
      <Testimonials />
      <Garagefaq />
      <Contact />
      <LocationFooter />
    </div>;
}